import { Paper } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SVG } from 'components/Asset/SVG';
import { CustomLoadingButton } from 'components/Buttons/CustomLoadingButton/CustomLoadingButton';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import { hasAccessToMultipleCustomers } from 'utils/validators/role.validation';
import { useTranslation } from 'react-i18next';

export const NoAccessView = () => {
  const { t } = useTranslation();
  const role = useAppSelector((state) => state.authReducer.role);
  const navigate = useNavigate();
  const paragraphs: Record<string, string> = {
    one: `You do not have permission to access this page with your current account.`,
    two: `You may log out and sign in again using the same or a different account with the required access.`,
  };

  const paragraphItems = Object.keys(paragraphs);

  const handleLogout = () => {
    navigate('/logging-out');
  };

  const handleCustomerSelection = () => {
    navigate('/customer-selection');
  };

  return (
    <Box
      width={'100vw'}
      height={'100vh'}
      border={'1px solid red'}
      margin={'auto'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Paper
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
          justifyContent: 'center',
          width: '500px',
          p: 3,
          bgcolor: 'white',
        }}
      >
        <SVG
          name="symboticwareLogoFull"
          style={{ paddingBottom: '26px', height: '200px', width: '300px' }}
        />
        {paragraphItems.map((key) => (
          <Typography
            id={`para-${key}`}
            key={`para-key-${key}`}
            variant="body2"
            component="h2"
            display="block"
            paddingBottom="14px"
          >
            {paragraphs[key]}
          </Typography>
        ))}

        <Box display={'flex'} alignItems={'center'} gap={4}>
          {role && hasAccessToMultipleCustomers(role) ? (
            <CustomLoadingButton
              variant="outlined"
              color="info"
              onClick={handleCustomerSelection}
            >
              {t('back_to_customer_selection')}
            </CustomLoadingButton>
          ) : null}
          <CustomLoadingButton
            variant="outlined"
            color="error"
            onClick={handleLogout}
          >
            {t('logout_and_sign_in_again')}
          </CustomLoadingButton>
        </Box>
      </Paper>
    </Box>
  );
};
